import * as Yup from 'yup';
import i18n from '../../../translations/strings';
export const ValidationConfirmResetPassword = Yup.object({
  password: Yup.string()
    .required(i18n.t('common.requiredField'))
    .min(8, i18n.t('registration.passwordShort'))
    .max(32, i18n.t('registration.passwordLong'))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      i18n.t('registration.passwordError'),
    ),
  confirm_password: Yup.string()
    .required(i18n.t('common.requiredField'))
    .oneOf([Yup.ref('password')], i18n.t('registration.confirmPasswordError')),
});
